import type { Scores, POIs } from "@local-logic/client";
import type { ScoreCategories } from "~/sdks/LocalContentDeprecated/types";

export interface ScoreCategory {
  value: ScoreCategories;
  scores: Partial<keyof Scores["location"]>[];
}

export const scoreCategories: ScoreCategory[] = [
  {
    value: "commute",
    scores: [
      "transit_friendly",
      "car_friendly",
      "pedestrian_friendly",
      "cycling_friendly",
    ],
  },
  {
    value: "education",
    scores: ["primary_schools", "high_schools", "daycares"],
  },
  {
    value: "amenities",
    scores: ["groceries", "restaurants", "shopping", "cafes"],
  },
  {
    value: "character",
    scores: ["quiet", "nightlife", "vibrant", "historic"],
  },
  {
    value: "nature",
    scores: ["parks", "greenery"],
  },
  {
    value: "wellness",
    scores: ["wellness"],
  },
];

export const scorePois: Partial<
  Record<keyof Scores["location"], (keyof POIs)[]>
> = {
  // Commute
  pedestrian_friendly: [],
  transit_friendly: ["rapid_transit_stations", "train_stations", "bus_stops"],
  cycling_friendly: [],
  car_friendly: ["car_fueling_stations"],

  // Amenities
  groceries: ["groceries", "groceries_specialized"],
  restaurants: ["restaurants", "healthy_restaurants"],
  cafes: ["cafes"],
  shopping: ["shopping"],

  // Nature
  parks: ["parks"],
  greenery: [],

  // Character
  vibrant: ["art_culture_science"],
  nightlife: ["nightlife"],
  quiet: [],
  historic: [],

  // Education
  high_schools: [],
  primary_schools: [],
  daycares: ["daycares"],

  // Wellness
  wellness: [
    "fitness",
    "healthy_restaurants",
    "health_care",
    "groceries",
    "sport_facilities",
    "parks",
  ],
};
